document.addEventListener('DOMContentLoaded', function() {
    console.log('Script loaded');
    console.log('Default Carat:', window.defaultCarat);
    console.log('Default Stone:', window.defaultStone);
    console.log('Default Metal:', window.defaultMetal);

   // Handle Gem Weight
var defaultGemWeight = window.defaultCarat; // You may want to rename this variable for clarity
if (defaultGemWeight) {
    var gemWeightRadios = document.querySelectorAll('input[name="Gem Weight"]'); // Changed to "Gem Weight"
    var gemWeightFound = false;
    gemWeightRadios.forEach(function(radio) {
        if (radio.value === defaultGemWeight.toString()) {
            radio.checked = true;
            console.log('Radio button for gem weight ' + defaultGemWeight + ' selected');

            // Dispatch change event
            var event = new Event('change', { bubbles: true });
            radio.dispatchEvent(event);
            gemWeightFound = true;
        }
    });

    if (!gemWeightFound) {
        console.error('Radio button for gem weight ' + defaultGemWeight + ' not found');
    }
} else {
    console.error('No default gem weight value found');
}


 // Handle Stone
var defaultGemStone = window.defaultStone;
if (defaultGemStone) {
    var gemStoneRadios = document.querySelectorAll('input[name="Gem Stone"]');
    console.log('Default Gem Stone:', defaultGemStone); // Log the default value
    console.log('Available Gem Stones:'); // Log available values
    gemStoneRadios.forEach(function(radio) {
        console.log('Radio Value:', radio.value); // Log each radio value
    });

    var gemStoneFound = false;
    gemStoneRadios.forEach(function(radio) {
        if (radio.value === defaultGemStone) {
            radio.checked = true;
            console.log('Radio button for gem stone ' + defaultGemStone + ' selected');

            // Dispatch change event
            var event = new Event('change', { bubbles: true });
            radio.dispatchEvent(event);
            gemStoneFound = true;
        }
    });

    if (!gemStoneFound) {
        console.error('Radio button for gem stone ' + defaultGemStone + ' not found');
    }
} else {
    console.error('No default gem stone value found');
}




    // Handle Metal
    var defaultMetal = window.defaultMetal;
    if (defaultMetal) {
        var metalRadios = document.querySelectorAll('input[name="Metal"]');
        var metalFound = false;
        metalRadios.forEach(function(radio) {
            if (radio.value === defaultMetal) {
                radio.checked = true;
                console.log('Radio button for metal ' + defaultMetal + ' selected');

                // Dispatch change event
                var event = new Event('change', { bubbles: true });
                radio.dispatchEvent(event);
                metalFound = true;
            }
        });

        if (!metalFound) {
            console.error('Radio button for metal ' + defaultMetal + ' not found');
        }
    } else {
        console.error('No default metal value found');
    }
});
